// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_tqt","cls2":"LoswpTabsHero-cls2_3_H LoswpTabsHero-cls1_tqt"};